import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Typography
} from "@mui/material";
import FilterButtons from "../FilterButtons.js";
import styles from "./chart-dialog.module.css";

export function ChartDialog({ 
  title, 
  children, 
  trigger, 
  isTableView = false, 
  isOpen, 
  setIsOpen, 
  showFilterButton = false 
}) {
  const [open, setOpen] = useState(setIsOpen ? undefined : false);

  const handleClose = () => {
    if (setIsOpen) {
      setIsOpen(false);
    } else {
      setOpen(false);
    }
  };

  const handleOpen = () => {
    if (setIsOpen) {
      setIsOpen(true);
    } else {
      setOpen(true);
    }
  };

  const isDialogOpen = setIsOpen ? isOpen : open;

  return (
    <>
      <Box onClick={handleOpen} className={styles.trigger}>
        {trigger}
      </Box>
      <Dialog
        open={isDialogOpen}
        onClose={handleClose}
        maxWidth={false}
        className={styles.dialog}
        PaperProps={{
          className: styles.dialogPaper
        }}
      >
        <DialogContent className={styles.dialogContent}>
          <Box className={styles.contentContainer}>
            <Box className={styles.dialogHeader}>
              <DialogTitle className={styles.dialogTitle}></DialogTitle>
              {!showFilterButton && (
                <FilterButtons showWeeks={false} />
              )}
            </Box>
            
            <Box className={`${styles.chartContainer} ${
              isTableView ? styles.tableViewContainer : styles.graphViewContainer
            }`}>
              <img
                src="/assets/cardBg.png"
                width={400}
                height={400}
                alt="Glow"
                className={styles.backgroundImage}
              />

              <Typography className={styles.chartTitle}>
                {title}
              </Typography>

              <Box className={`${styles.contentWrapper} ${
                isTableView ? styles.tableViewContent : ""
              }`}>
                {children}
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}